PluginButtonsView = require 'views/plugin/plugin-buttons-view'
PluginCardButtonView = require 'views/plugin/plugin-card-button-view'
t = require('views/internal/teacup-with-helpers')('card_detail')

template = t.renderable ->
  t.h3 ->
    t.format 'plugins'
  t.div '.u-clearfix.js-button-list'

module.exports = class PluginCardButtonsView extends PluginButtonsView
  tagName: 'div'
  className: 'window-module u-clearfix hide'
  buttonsSelector: '.js-button-list'
  buttonView: PluginCardButtonView

  renderContainer: ->
    @$el.html(template())
    @$('.js-button-list')

  runnerOptions: ->
    command: 'card-buttons'
    board: @model.getBoard()
    card: @model



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-card-buttons-view.coffee